var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceExtraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2849 14.3321C22.2849 18.6432 18.7901 22.138 14.479 22.138C10.168 22.138 6.67322 18.6432 6.67322 14.3321C6.67322 10.0211 10.168 6.52632 14.479 6.52632C18.7901 6.52632 22.2849 10.0211 22.2849 14.3321Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.05263
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4792 24.0155C16.4778 24.0155 18.3359 23.4046 19.8795 22.3638C22.3112 22.7127 24.305 23.3965 25.6982 24.6189C27.0173 25.7763 27.8569 27.4691 27.9584 29.9952H1C1.10148 27.4692 1.94124 25.7763 3.26045 24.6189C4.65389 23.3965 6.64777 22.7127 9.07947 22.3638C10.6225 23.405 12.4807 24.0155 14.4792 24.0155Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.05263
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4582 24.2396C34.6066 21.0913 34.6066 15.9867 31.4582 12.8384C28.3099 9.69 23.2054 9.69001 20.057 12.8384C16.9086 15.9867 16.9086 21.0913 20.057 24.2396C23.2054 27.388 28.3099 27.388 31.4582 24.2396Z",
    fill: "#3C3C3C",
    stroke: "#3C3C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2494 18.539H29.2656",
    stroke: "white",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7577 22.0471V15.031",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceExtraIcon);
export default __webpack_public_path__ + "static/media/price_extra_icon.c54e98c57d03d4eb56eae5acea251208.svg";
export { ForwardRef as ReactComponent };